import React from "react";

export default function CustomYTick({ x, y, payload }) {
  const formatNumber = (value) => {
    if (value >= 1000) {
      const roundedValue = value / 1000;
      return `${roundedValue}k`;
    } 
    return value;
  };

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={5}
        dx={-50}
        fill="#ffffff"
        textAnchor="end"
        style={{ fontSize: "0.5625rem", direction: "ltr" }}
      >
        {formatNumber(payload.value)}
      </text>
    </g>
  );
}
